<div class="td-wb-ticker-symbol__content">
  <!--Flag icon-->
  @if (showMarketFlag()) {
    <td-wb-icon-flag class="td-wb-ticker-symbol__icon"
      [value]="market()"
      [title]="'tdWb.watchlist.overview.toolbar.MKT_' + market() | tdWbTranslate"
      [aria-label]="'tdWb.watchlist.overview.toolbar.MKT_' + market() | tdWbTranslate" />
  }

  <!--Security symbol with expand/collapse control-->
  <span class="td-wb-ticker-symbol__ticker"
        [class.td-wb-ticker-symbol__ticker--limit]="description() === undefined">
    <ng-container *ngTemplateOutlet="showLink() ? symbolLink : symbolText" />
  </span>

  <!--Description only for non-options-->
  @if (description() !== undefined) {
    <div
      class="td-wb-ticker-symbol__description"
      [attr.title]="description()"
      [innerText]="description()">
    </div>
  }
  <ng-content select="td-wb-fpl-on-loan" />
  <ng-content select="td-wb-ticker-symbol-warnings" />
</div>
@if (multiAssetFund()) {
  <td-wb-icon iconId="pie-chart"
    iconType="secondary"
    size="18" />
}

<ng-template #symbolLink>
  @if (tickerSymbol() !== '') {
    <a class="td-wb-ticker-symbol__link"
       href=""
       role="button"
       [attr.id]="'td-wb-aria-symbol-title-' + tickerSymbol()"
       [attr.name]="tickerSymbol() + '_Toggle'"
       [attr.aria-expanded]="clickNotToggle() ? undefined : rowExpanded"
       [innerText]="tickerSymbol()"
       (click)="toggleExpandRow()">
    </a>
  }
</ng-template>

<ng-template #symbolText>
  <span [innerText]="tickerSymbol()"></span>
</ng-template>
